webpackJsonp([0],{

/***/ "0Td6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_mixroedores.4b8d1ce.jpg";

/***/ }),

/***/ "0p7L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amamos.35cdbb8.png";

/***/ }),

/***/ "1BaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section wow fadeIn"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-9 has-text-centered"},[_c('strong',[_vm._v("\n                    El Absorbente sanitario de marlo es producido por Nelsoni Ranch con mazorcas de maíz bajo métodos especiales de cosecha que aseguran una calidad de materias primas de primer nivel y un porcentaje de humedad por debajo del 10% lo que hace posible aprovechar su excepcional capacidad de absorción.\n                    Luego del proceso de triturado este producto se lo clasifica para obtener un producto libre de polvo, el cual brinda un ALTO PODER DE ABSORCION, RETIENE LOS OLORES y resulta muy RENDIDOR economizando su compra.\n\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1c46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_naturalhay_jpg__ = __webpack_require__("7qBo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_naturalhay_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_naturalhay_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_naturalhay_mobile_jpg__ = __webpack_require__("Aoh+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_naturalhay_mobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_naturalhay_mobile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_pasturas_henoenrama_jpg__ = __webpack_require__("Zz+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_pasturas_henoenrama_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_pasturas_henoenrama_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_pasturas_alfalfaenrama_jpg__ = __webpack_require__("IzRW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_pasturas_alfalfaenrama_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_pasturas_alfalfaenrama_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_pasturas_alfalfaencubos_jpg__ = __webpack_require__("SFjt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_pasturas_alfalfaencubos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_products_pasturas_alfalfaencubos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_products_pasturas_alfalfaenpellet_jpg__ = __webpack_require__("LqG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_products_pasturas_alfalfaenpellet_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_products_pasturas_alfalfaenpellet_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "naturalHayPasturas",
  data: function data() {
    return {
      data: [{
        html: " <h1>NATURAL HAY - PASTURAS</h1><p>Base nutricional de los roedores.<br>Favorece el buen desgaste de dientes y una optima digestión.</p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_pasturas_henoenrama_jpg___default.a,
        title: "HENO EN RAMA",
        description: "\n            Nutritivas pasturas curadas al sol. <br>\n            El Heno \u201CNelsoni Ranch\u201D constituye la base nutricional de conejos, cobayos, chinchillas, hamsters y otros peque\xF1os roedores. Es una delicia natural que proporciona fibra con bajo contenido de calcio, disminuyendo la probabilidad de enfermedades en el tracto urinario. <br>\n            El Heno \u201CNelsoni Ranch\u201D es esencial para la salud general de sus peque\xF1as mascotas, ya que ayuda en su proceso digestivo natural. Tambi\xE9n puede ser utilizado como cama.<br>\n            No Contiene ning\xFAn tipo de agregado ni conservantes.<br>\n            Se recomienda dar Heno \u201CNelsoni Ranch\u201D a su mascota junto con una comida nutritiva y balanceada como la l\xEDnea de Alimentos Balanceados \u201CNelsoni Ranch\u201D\n            Darle Heno \u201CNelsoni Ranch\u201D a su peque\xF1a mascota cuida la salud del cuerpo y los dientes d\xE1ndole bienestar general\n            (Los conejos, cobayos, chinchillas, hamsters y otros peque\xF1os animales tienen una necesidad innata de masticar con el fin de desgastar sus dientes incisivos que no paran de crecer )\n            Ingredientes: variedades de pasturas tales como Lotus, tr\xE9bol y cebadilla deshidratada al sol.\n            ",
        extraData: "Presentación 500 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_pasturas_alfalfaenrama_jpg___default.a,
        title: "ALFALFA EN RAMA",
        description: "Nutritiva pastura de alfalfa curada al sol<br>\n            La Alfalfa en Rama \u201CNelsoni Ranch\u201D es un complemento natural ideal para conejos, cobayos, chinchillas, hamsters y otros peque\xF1os roedores. <br>\n            Es una delicia que proporciona fibra. Tambi\xE9n puede ser utilizado como cama para su peque\xF1a mascota.<br>\n            Ingredientes: alfalfa deshidratada al sol.\n            ",
        extraData: "Presentación 500 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_products_pasturas_alfalfaencubos_jpg___default.a,
        title: "ALFALFA EN CUBOS",
        description: "Nutritivos bloques naturales de pastura de alfalfa curada al sol<br>\n          Los Cubos de Alfalfa \u201CNelsoni Ranch\u201D son un complemento natural ideal para conejos, cobayos, chinchillas, hamsters y otros peque\xF1os roedores.Los Cubos de Alfalfa \u201CNelsoni Ranch\u201D son esenciales para la salud general de los conejos, chinchillas, hamsters, cobayos y otros roedores, ya que ayuda en su proceso digestivo natural. <br>\n          No Contiene ning\xFAn tipo de agregado ni conservantes.<br>\n          Se recomienda dar Cubos de Alfalfa \u201CNelsoni Ranch\u201D a su mascota junto con una comida nutritiva y balanceada como la l\xEDnea de Alimentos Balanceados  \u201CNelsoni Ranch\u201D<br>\n          Darle Cubos de Alfalfa \u201CNelsoni Ranch\u201D a su peque\xF1a mascota cuida la salud del cuerpo y los dientes d\xE1ndole bienestar general<br>\n          Beneficios: \n          <br>\n          -\t100% aprovechamiento<br>\n          -\t65% de ahorro en el transporte y el almacenamiento<br>\n          -\tAlta digestibilidad <br>\n          -\t100% Natural<br>\n          -\tCalidad Constante <br>\n          -\tExcelente Palatabilidad <br>\n          -\tF\xE1cil dosificaci\xF3n<br>\n          -\tLibre de moho y polvo<br>\n          Informaci\xF3n nutricional: Prote\xEDna entre 23% y 27%<br>\n          Ingredientes: Alfalfa deshidratada al sol. <br>\n          ",
        extraData: "Presentación: 500 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_products_pasturas_alfalfaenpellet_jpg___default.a,
        title: "ALFALFA PELLET",
        description: "Los pellets de alfalfa de Nelsoni Ranch compuesto por las mejores alfalfas, manteniendo a su mascota vital y feliz. <br>\nComplemento esencial en la dieta de animales como conejos, cobayos, chinchillas, gerbos entre otros.<br>\nIngredientes: alfalfa.\n",
        extraData: "Presentación: 500 gr."
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_naturalhay_mobile_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_naturalhay_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "2qj8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_silvestres.4c4071f.jpg";

/***/ }),

/***/ "393w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs__ = __webpack_require__("q4TV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wowjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css__ = __webpack_require__("5M1/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_components_dataTable__ = __webpack_require__("3Oyo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "products",
  data: function data() {
    return {
      modalShow: false,
      modalImg: null,
      dataTable: "data-table"
    };
  },

  components: {
    dataTable: __WEBPACK_IMPORTED_MODULE_2__products_components_dataTable__["a" /* default */]
  },
  props: {
    products: {
      type: Array
    }
  },
  methods: {
    isActive: function isActive(flag) {
      if (flag) {
        return "is-active";
      }
    }
  },
  mounted: function mounted() {
    var lib = __WEBPACK_IMPORTED_MODULE_0_wowjs___default.a.WOW;
    var Wow = new lib();
    Wow.init();
  }
});

/***/ }),

/***/ "3CwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3MG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_completefood_jpg__ = __webpack_require__("VQz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_completefood_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_completefood_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_completefood_mobile_jpg__ = __webpack_require__("NsX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_completefood_mobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_completefood_mobile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_completefood_conejos_jpg__ = __webpack_require__("ArK4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_completefood_conejos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_completefood_conejos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_completefood_chinchillas_jpg__ = __webpack_require__("WKFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_completefood_chinchillas_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_completefood_chinchillas_jpg__);
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: "completeFood",
  data: function data() {
    return {
      data: [{
        html: " <h1>COMPLETE FOOD – ALL IN ONE</h1><p>Se recomienda incorporar en la dieta de Conejos, Chinchillas y Cobayos, verduras frescas, pasturas de Heno, alfalfas en cubo, rama o pellets.<br> Las pasturas son la base nutricional de estos roedores.</p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_completefood_conejos_jpg___default.a,
        title: "ALIMENTO BALANCEADO PARA CONEJOS",
        description: "El Balanceado para Conejos de Nelsoni Ranch provee una optima nutrici\xF3n con todas las vitaminas y nutrientes, manteniendo a su roedor vital y feliz.<br>\n          Especialmente formulado para diferentes variedades de conejos, balanceado cr\xEDa profesional. <br>\n          Se recomienda incorporar en la dieta de todo conejo verduras frescas, Heno Nelsoni Ranch, alfalfas en cubo, rama o pellets. Las pasturas son la base nutricional de los roedores.<br>\n          Ingredientes: alfalfa, cascarilla de soja, expeler de girasol integral, afrecho de arroz, zeolita, n\xFAcleo vitam\xEDnico AD3E, sal.<br>\n          Composici\xF3n centesimal: prote\xEDna bruta 16% min. Grasa bruta 3% min. Fibra bruta 20% min. /25% m\xE1x.  Humedad 13% m\xE1x. Calcio 0,8% min. /1% m\xE1x. F\xF3sforo 0,4% min. /0,5% m\xE1x.  <br>\n          Aditivos por kg: VIT A 10000 UI / VIT D3 1500UI / VIT E 50UI<br>\n          Energ\xEDa Metabolizante: 1800 Kcal por kg ",
        extraData: "Presentación 750 gr. y bolsas de 10 Kg.",
        component: {
          name: 'data-table',
          type: 'conejos'
        }
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_completefood_chinchillas_jpg___default.a,
        title: "MIX CHINCHILLAS",
        description: "La chinchilla tiene requerimientos espec\xEDficos y no debe ser alimentada con formulas para otros roedores. La composici\xF3n de este alimento esta adaptado a sus exigencias biol\xF3gicas.<br> Se le puede brindar tanto a animales de cr\xEDa como a las mascotas. Ingredientes: pellets compuestos por alfalfa de primera calidad, vitaminas y minerales esenciales para mejorar el pelo, combatir el estr\xE9s, previene enfermedades hep\xE1ticas y contiene probi\xF3ticos para facilitar absorci\xF3n de nutrientes.",
        extraData: "Presentación 750 gr. y bolsas de 10 Kg.",
        component: {
          name: 'data-table',
          type: 'chinchillas'
        }
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_completefood_mobile_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_completefood_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "3Oyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataTable_vue__ = __webpack_require__("U70l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea6a24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataTable_vue__ = __webpack_require__("PLhZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea6a24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3RrP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3jVG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/suplementos_calcioaves.ea902d1.jpg";

/***/ }),

/***/ "4YMM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4puZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_mijo.4e0a0b0.jpg";

/***/ }),

/***/ "5M1/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5dYx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-content'),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5w5x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_mixaves_mobile.4eb4a60.jpg";

/***/ }),

/***/ "7qBo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_naturalhay.3035c79.jpg";

/***/ }),

/***/ "7seW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_suplementos_jpg__ = __webpack_require__("flZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_suplementos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_suplementos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_products_suplementos_calcioaves_jpg__ = __webpack_require__("3jVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_products_suplementos_calcioaves_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_products_suplementos_calcioaves_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_suplementos_hical_jpg__ = __webpack_require__("vgE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_suplementos_hical_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_suplementos_hical_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_suplementos_calcioreptiles_jpg__ = __webpack_require__("wgpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_suplementos_calcioreptiles_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_suplementos_calcioreptiles_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_suplementos_eggbiscuits_jpg__ = __webpack_require__("X8G4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_suplementos_eggbiscuits_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_products_suplementos_eggbiscuits_jpg__);
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "suplementos",
  data: function data() {
    return {
      data: [{
        html: " <h1>SUPLEMENTOS</h1> <p>Para crear una dieta sana y nutritiva.</p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_8__assets_images_products_suplementos_calcioaves_jpg___default.a,
        title: "CALCIO PARA AVES",
        description: "\n-\tPromueve la adecuada formaci\xF3n del cascaron del huevo durante la temporada de cria.<br>\n-\tFavorece el desarrollo del esqueleto en aves jovenes<br>\n-\tSe utiliza para el tratamiento y la prevenci\xF3n de la deficiencia de calcio<br>\n-\tSuplemento diet\xE9tico org\xE1nico <br>\nModo de empleo:<br>\nNelsoni Ranch recomienda consultar a un especialista para adecuar la dieta de su mascota. La dosificaci\xF3n recomendada es un 2% de Calcio sobre la raci\xF3n, para que resulte mas f\xE1cil puede usarse similar a la sal espolvoreando sobre el alimento. <br>Se aprovecha muy bien en alimentos como pastones, bizcocho, pasta de huevo, frutas e insectos dependiendo la dieta<br>\nRecuerde que el calcio en las aves asegura una buena formaci\xF3n de la c\xE1scara del huevo y estimula la creaci\xF3n de un esqueleto sano\n",
        extraData: "Presentación: 120 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_suplementos_hical_jpg___default.a,
        title: "HI-CAL GRIT",
        description: "\n-\tSuplemento mineral para Aves<br>\n-\tEl Grit es utilizado por las aves para ayudar en la digesti\xF3n de las semillas enteras e intactas. Por lo tanto, favorece la molienda y el desgaste de las capas exteriores de las semillas, permitiendo a las enzimas digestivas llegar a la parte interna tan valiosa.<br>\n-\tEl Grit es org\xE1nico, el mismo se digiere f\xE1cilmente evitando que se acumule en el sistema digestivo. Al mismo tiempo proporciona el calcio adicional y otros minerales importantes para las aves alimentadas con una dieta a base de semillas <br>\n-\tInstrucciones: mezclar con el Mix de semillas a raz\xF3n de un 2 % de Grit. <br>\nTambi\xE9n puede administrarse en cazuelas o leng\xFCeteros de manera permanente para que el ave regule seg\xFAn su necesidad.\n",
        extraData: "Presentación: 120 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_suplementos_calcioreptiles_jpg___default.a,
        title: "CALCIO PARA REPTILES (Oyster Shell) ",
        description: "Es una excelente fuente de calcio para todos los reptiles y anfibios. Compuesto por 100% carbonato de calcio organico.<br>\n-\tModo Empleo:<br>\n-\tEspolvorear sobre frutas y verduras, hasta que quede una peque\xF1a capa de calcio. Si va a alimentar con insectos:<br>\n-\t1- Colocar el Calcio para Reptiles Nelsoni Ranch en un recipiente<br>\n-\t2- Coloque los insectos dentro del recipiente<br>\n-\t3- Agitar suavemente hasta que est\xE9n completamente cubiertos  \n",
        extraData: "Presentación: 120 gr."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_products_suplementos_eggbiscuits_jpg___default.a,
        title: "EGG BISCUITS",
        description: "-\tLa prote\xEDna del huevo es una fuente muy importante para mantener a las aves en buenas condiciones y obtener buenos resultados de cr\xEDa. <br>\n-\tModo de Empleo: <br>\n-\t1- Listo para usar. Puede emplearse con o sin agregado de agua <br>\n-\t2- Proporcionar de 1 a 3 cucharaditas por porci\xF3n. Periodo de descanso: 2 a 3 veces por semana. Periodo de cr\xEDa: 2 a 3 veces por d\xEDa seg\xFAn las necesidades. Periodo de muda: todos los d\xEDas. <br>\n-\tSe puede proporcionar a todas las aves. <br>\n-\tPara mejores resultados, descartar cualquier porci\xF3n no consumida y mantener el recipiente de comida limpio para la siguiente porci\xF3n.  <br>\n-\tINGREDIENTES: huevos frescos, semillas de ch\xEDa, harina de trigo y azucar.   \n\n",
        extraData: "Presentación: 120 gr."
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_suplementos_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_suplementos_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "8lRM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_mixroedores_mobile.ffd47fc.jpg";

/***/ }),

/***/ "8nYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beddingAndLitterCamas_vue__ = __webpack_require__("VqlE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9afbb844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_beddingAndLitterCamas_vue__ = __webpack_require__("1BaC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beddingAndLitterCamas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9afbb844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_beddingAndLitterCamas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bp2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.2812455.jpg";

/***/ }),

/***/ "9ldH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9nby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('nav',{staticClass:"navbar navbar-nelsoni "},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item ",class:_vm.path('#/'),attrs:{"to":"/"}},[_c('span',{staticClass:"icon-logoNelsoniRanch_blanco"})]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",attrs:{"id":"menu"}},[_c('div',{staticClass:"navbar-end"},[_c('router-link',{staticClass:"navbar-item ",class:_vm.path(['/productos','/bedding-and-litter-camas', '/natural-hay-pasturas', '/natural-mix-aves', '/natural-mix-roedores', '/complete-food', '/suplementos']),attrs:{"to":"/productos"}},[_vm._v("Productos")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item ",class:_vm.path('/nosotros'),attrs:{"to":"nosotros"}},[_vm._v("Nosotros")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item ",class:_vm.path('/contacto'),attrs:{"to":"contacto"}},[_vm._v("Contacto")]),_vm._v(" "),_vm._m(1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-burger burger",attrs:{"data-target":"menu"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-item social-item"},[_c('a',{attrs:{"href":"https://www.facebook.com/NelsoniRanch","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-facebook-official",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/nelsoniranch ","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-instagram",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9qjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixroedores_jpg__ = __webpack_require__("0Td6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixroedores_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixroedores_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixroedores_mobile_jpg__ = __webpack_require__("8lRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixroedores_mobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixroedores_mobile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixroedores_hamsters_jpg__ = __webpack_require__("f0Vq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixroedores_hamsters_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixroedores_hamsters_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixroedores_cobayos_jpg__ = __webpack_require__("PAqT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixroedores_cobayos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixroedores_cobayos_jpg__);
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: "naturalMixRoedores",
  data: function data() {
    return {
      data: [{
        html: " <h1>NATURAL MIX ROEDORES</h1><p>Alimento a base de materias primas de primera calidad que constituye una dieta balanceada a la medida de su mascota</p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixroedores_hamsters_jpg___default.a,
        title: "MIX HAMSTER",
        description: "El Mix para H\xE1mster de Nelsoni Ranch, posee una selecci\xF3n especial de semillas y esta fortificado con extrusado  balanceado, manteniendo a su roedor vital y feliz. <br>\nSe recomienda suplementar con pasturas y frutas.<br>\nIngredientes: trigo, girasol, ma\xEDz entero, sorgo, avena, con vitaminas.\n ",
        extraData: "Presentación 750 gr. y 30 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixroedores_cobayos_jpg___default.a,
        title: "MIX COBAYO",
        description: "El Mix para Cobayo de Nelsoni Ranch esta Especialmente formulado para diferentes variedades de cobayo. Su mayor componente es el balanceado especifico de cobayos y contiene semillas en menor cantidad, componente nutritivo y recreativo a la vez.<br>\nSe recomienda incorporar en la dieta de todo cobayo frutas frescas, Heno de pasturas Nelsoni Ranch, alfalfas en cubo, rama o pellets. <br>\nIngredientes: trigo,  avena, cebada. Pellet compuestos por: cascarilla de soja, expeler de girasol, cebada, afrecho de arroz, afrecho de trigo, soja entera, alfalfa, carbonato de calcio, oligosac\xE1ridos m\xE1nanos, n\xFAcleo vitam\xEDnico ACD3E, sal.\n ",
        extraData: "Presentación 750 gr. y 30 kilos."
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixroedores_mobile_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixroedores_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "A1ge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_aboutUs_nosotros_titulo_jpg__ = __webpack_require__("IG3Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_aboutUs_nosotros_titulo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_aboutUs_nosotros_titulo_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      data: [{
        html: ' <h1><small style="font-weight: lighter;">SOBRE</span><br> <span style="font-weight: normal;">NOSOTROS</span></h1>',
        style: "background:url(" + __WEBPACK_IMPORTED_MODULE_3__assets_images_aboutUs_nosotros_titulo_jpg___default.a + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */]
  }
});

/***/ }),

/***/ "Aoh+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_naturalhay_mobile.4cc733a.jpg";

/***/ }),

/***/ "ArK4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/completefood_conejos.c282351.jpg";

/***/ }),

/***/ "AzBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "contact"
});

/***/ }),

/***/ "BTe3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "By9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalMixRoedores_vue__ = __webpack_require__("9qjj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3828992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalMixRoedores_vue__ = __webpack_require__("KV+y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalMixRoedores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3828992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalMixRoedores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C0jm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bio.fd57ac9.png";

/***/ }),

/***/ "CLTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suplementos_vue__ = __webpack_require__("7seW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c4caef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suplementos_vue__ = __webpack_require__("y/vF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suplementos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c4caef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suplementos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CMs/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a88ee43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("9nby");
function injectStyle (ssrContext) {
  __webpack_require__("Up9V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a88ee43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E8nv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bedding_marlopararoedores.a368a74.jpg";

/***/ }),

/***/ "EQB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EZOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs__ = __webpack_require__("q4TV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wowjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css__ = __webpack_require__("5M1/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wowjs_css_libs_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide',
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    dynamicHeight: function dynamicHeight() {
      return window.innerWidth < 769 ? '300px' : '550px';
    }
  },
  mounted: function mounted() {
    var lib = __WEBPACK_IMPORTED_MODULE_0_wowjs___default.a.WOW;
    var Wow = new lib();
    Wow.init();

    var flag = false;

    if (this.data.length > 1) {
      flag = true;
    }

    $('.carousel').flickity({
      cellAlign: 'left',
      contain: true,
      prevNextButtons: flag,
      pageDots: flag
    });
  }
});

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_arrowUp_vue__ = __webpack_require__("mdd+");
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      data: [{
        html: ' <h1><span>BIENVENIDOS A</span><br>  NELSONI RANCH </h1><p> Nos renovamos, apostando al cambio y a la evoluci&oacute;n permanente </p>',
        className: "banner1",
        link: {
          href: 'nosotros',
          text: 'Conocé nuestra historia'
        }
      }, {
        html: '<h1><span>NUTRITIVAS PASTURAS<br> CURADAS AL SOL</h1><p>Las pasturas como el Heno y la Alfalfa <br>son la base nutricional de los roedores tales como<br> cobayos, conejos, chinchillas, hamsters, gerbos, etc. </p>',
        className: "banner2",
        link: {
          href: 'productos',
          text: 'VER PRODUCTOS'
        }

      }, {
        html: ' <h1>MARLO PARA GATOS</h1><p>Biodegradable, súper absorbente y elimina olores.Además es ultra liviano facilitando la limpieza y el descarte. </p>',
        className: "banner3",
        link: {
          href: 'productos',
          text: 'VER PRODUCTOS'
        }

      }]
    };
  },

  components: {
    'webHeader': __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    'webSlide': __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    'webContent': __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    'webParallax': __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    'webFooter': __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    'webArrowUp': __WEBPACK_IMPORTED_MODULE_5__components_arrowUp_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "GK12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GaaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completeFood_vue__ = __webpack_require__("3MG5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f07fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completeFood_vue__ = __webpack_require__("gfTk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completeFood_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f07fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completeFood_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HXVv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/piramide_pasturas.674aeae.jpg";

/***/ }),

/***/ "Hkbg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_girasol.4612b40.jpg";

/***/ }),

/***/ "HwwY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9g3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__ = __webpack_require__("393w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73cc1b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__ = __webpack_require__("IRRh");
function injectStyle (ssrContext) {
  __webpack_require__("9ldH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73cc1b9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73cc1b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IG3Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nosotros_titulo.439d99a.jpg";

/***/ }),

/***/ "IRRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('section',[_c('div',{staticClass:"modal",class:_vm.isActive(_vm.modalShow)},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('p',{staticClass:"image is-4by4"},[_c('img',{attrs:{"src":_vm.modalImg,"alt":""}})])]),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.modalShow = !_vm.modalShow}}})])]),_vm._v(" "),_vm._l((_vm.products),function(item){return _c('section',{staticClass:"section wow fadeIn"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(item.description)}}),_vm._v(" "),_c('p',{staticClass:"extraData"},[_c('strong',{domProps:{"innerHTML":_vm._s(item.extraData)}})])]),_vm._v(" "),_c('div',{staticClass:"column is-3 box-img",on:{"click":function($event){_vm.modalShow = true, _vm.modalImg = item.image}}},[_c('img',{attrs:{"src":item.image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"column is-2"})]),_vm._v(" "),(item.component && item.component.name === _vm.dataTable)?_c('div',[_c('data-table',{attrs:{"type":item.component.type}})],1):_vm._e()])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IzRW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pasturas_alfalfaenrama.1a66f16.jpg";

/***/ }),

/***/ "KV+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kgxf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.9732286.jpg";

/***/ }),

/***/ "LqG9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pasturas_alfalfaenpellet.b94d624.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32126288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("oYez");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32126288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOSm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_arrowUp_vue__ = __webpack_require__("mdd+");
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_5__components_arrowUp_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Mccf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bulma_css_bulma_css__ = __webpack_require__("GK12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bulma_css_bulma_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bulma_css_bulma_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_font_awesome_min_css__ = __webpack_require__("3RrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_logo_css__ = __webpack_require__("BTe3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_logo_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NSnt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.d2b5a91.jpg";

/***/ }),

/***/ "NsX0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_completefood_mobile.a098745.jpg";

/***/ }),

/***/ "OLGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs__ = __webpack_require__("q4TV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wowjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wowjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_categories_1_jpg__ = __webpack_require__("9bp2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_categories_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_categories_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_categories_2_jpg__ = __webpack_require__("TMRu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_categories_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_categories_2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_categories_3_jpg__ = __webpack_require__("jE5B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_categories_3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_categories_3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_categories_4_jpg__ = __webpack_require__("tPY+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_categories_4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_categories_4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_categories_5_jpg__ = __webpack_require__("NSnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_categories_5_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_categories_5_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_categories_6_jpg__ = __webpack_require__("Kgxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_categories_6_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_categories_6_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wowjs_css_libs_animate_css__ = __webpack_require__("5M1/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wowjs_css_libs_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_wowjs_css_libs_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'content',
  data: function data() {
    return {
      categories: [[{
        title: 'BEDDING & LITTER <br> CAMAS',
        image: __WEBPACK_IMPORTED_MODULE_1__assets_images_categories_1_jpg___default.a,
        description: 'Marlo para Gatos - Marlo para Roedores - Viruta de Marlo',
        link: 'bedding-and-litter-camas',
        delay: '.1s'
      }, {
        title: 'NATURAL HAY <br> PASTURAS',
        image: __WEBPACK_IMPORTED_MODULE_2__assets_images_categories_2_jpg___default.a,
        description: 'Alfalfa en Pellets - Alfalfa en Rama - Alfalfa en Cubos - Heno en rama',
        link: 'natural-hay-pasturas',
        delay: '.5s'
      }, {
        title: 'NATURAL MIX<br> AVES',
        image: __WEBPACK_IMPORTED_MODULE_3__assets_images_categories_3_jpg___default.a,
        description: ' Mix Canarios - Mix Silvestres - Mix Periquitos - Mix Loreos - Mijo con Vitaminas - Girasol Confitero - Alpiste con Vitaminas',
        link: 'natural-mix-aves',
        delay: '.9s'
      }], [{
        title: 'NATURAL MIX <br> ROEDORES',
        image: __WEBPACK_IMPORTED_MODULE_4__assets_images_categories_4_jpg___default.a,
        description: ' Mix Hamster - Mix Cobayos',
        link: 'natural-mix-roedores',
        delay: '1.3s'
      }, {
        title: 'COMPLETE FOOD <br> (ALL IN ONE)',
        image: __WEBPACK_IMPORTED_MODULE_5__assets_images_categories_5_jpg___default.a,
        description: 'Alimento para conejos - Alimento para Chinchillas',
        link: 'complete-food',
        delay: '1.7s'
      }]]
    };
  },
  mounted: function mounted() {
    // const lib = WOW.WOW
    // const Wow = new lib()
  }
});

/***/ }),

/***/ "OZUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1EU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PAqT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixroedores_cobayos.c38aca1.jpg";

/***/ }),

/***/ "PLhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === _vm.conejos)?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.type === _vm.chinchillas)?_c('div',[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-8"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('strong',[_vm._v("COMPOSICION CENTESIMAL")])]),_vm._v(" "),_c('table',{staticClass:"table is-bordered is-striped is-narrow is-fullwidth"},[_c('tr',[_c('td',[_vm._v("PROTEINA BRUTA")]),_vm._v(" "),_c('td',[_vm._v("16% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FIBRA BRUTA ")]),_vm._v(" "),_c('td',[_vm._v("20% Mín. - 25% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FIBRA BRUTA")]),_vm._v(" "),_c('td',[_vm._v(" 20% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("GRASA BRUTA")]),_vm._v(" "),_c('td',[_vm._v(" 3% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("CALCIO ")]),_vm._v(" "),_c('td',[_vm._v("0,8% Mín. - 1 % Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FOSFORO ")]),_vm._v(" "),_c('td',[_vm._v("0,4% Mín. - 0,5% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("HUMEDAD")]),_vm._v(" "),_c('td',[_vm._v(" 13% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Energía Metabolizante ")]),_vm._v(" "),_c('td',[_vm._v("1.800 Kcal por kg.")])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_c('strong',[_vm._v("ADITIVOS por kg")])]),_vm._v(" "),_c('table',{staticClass:"table is-bordered is-striped is-narrow is-fullwidth"},[_c('tr',[_c('td',[_vm._v(" VITAMINA A")]),_vm._v(" "),_c('td',[_vm._v(" 10.000 UI.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("VITAMINA D3")]),_vm._v(" "),_c('td',[_vm._v(" 1.500 UI.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("VITAMINA E ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    50 UI.")])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-8"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_c('strong',[_vm._v("COMPOSICION CENTESIMAL")])]),_vm._v(" "),_c('table',{staticClass:"table is-bordered is-striped is-narrow is-fullwidth"},[_c('tr',[_c('td',[_vm._v("PROTEINA BRUTA")]),_vm._v(" "),_c('td',[_vm._v("17% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FIBRA BRUTA ")]),_vm._v(" "),_c('td',[_vm._v("18% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FIBRA BRUTA")]),_vm._v(" "),_c('td',[_vm._v(" 20% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("GRASA BRUTA")]),_vm._v(" "),_c('td',[_vm._v(" 3% Mín.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("CALCIO ")]),_vm._v(" "),_c('td',[_vm._v(" 0,9% Mín. - 1 % Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FOSFORO ")]),_vm._v(" "),_c('td',[_vm._v("0,4% Mín. - 0,6% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("HUMEDAD")]),_vm._v(" "),_c('td',[_vm._v(" 13% Máx.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Energía Metabolizante ")]),_vm._v(" "),_c('td',[_vm._v("2.300 Kcal por kg.")])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_c('strong',[_vm._v("ADITIVOS por kg")])]),_vm._v(" "),_c('table',{staticClass:"table is-bordered is-striped is-narrow is-fullwidth"},[_c('tr',[_c('td',[_vm._v(" VITAMINA A")]),_vm._v(" "),_c('td',[_vm._v(" 9.000 UI.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("VITAMINA D3 ")]),_vm._v(" "),_c('td',[_vm._v(" 900 UI.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("VITAMINA E ")]),_vm._v(" "),_c('td',[_vm._v(" 90 UI.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("VITAMINA C ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    75 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Cloruro colina ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    150 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Cu ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    30 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Zn ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    80 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Mn ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    40 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Fe ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    50 mg.")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Se ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    0,4 mg.")])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0Ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('web-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section main-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-8"},[_c('h1',{staticClass:"title"},[_vm._v("\n              Nuestra Historia\n            ")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n            Impulsados por la pasión por los animales se formó Nelsoni Ranch, desde nuestro lugar como aficionados por las mascotas sentimos el compromiso de desarrollar productos para favorecer el bienestar y una correcta nutrición de animales en cautiverio. "),_c('br'),_c('br'),_vm._v("\nNuestros comienzos datan del año 2000 construyendo el criadero de insectos más grande de la Argentina para la alimentación de animales exóticos.   "),_c('br'),_c('br'),_vm._v("\nPara el año 2007 diversificamos nuestra actividad incorporando una línea propia de alimentos para pequeñas mascotas, siempre priorizando la calidad del alimento."),_c('br'),_c('br'),_vm._v("\nMotivados por la falta de alimentos específicos  para las diferentes especies de animales, nos fuimos focalizando en elaborar productos que se adapten a cada una de las especies, según sus necesidades naturales."),_c('br'),_c('br'),_vm._v("\nPara fines del año 2009 incorporamos una línea nueva de productos dedicados a la higiene y bienestar de pequeños roedores y gatos. Elaborados en nuestra planta, lanzamos absorbentes sanitarios compuestos por mazorcas de maíz. Productos totalmente orgánicos  y biodegradables. "),_c('br'),_c('br'),_vm._v("\nA principios del año 2014 se decide instalar la planta de producción en San Pedro (Provincia de Buenos Aires) ampliando la capacidad y acercándonos a los procesos de producción agropecuaria de las materias primas que se utilizarán en la línea de productos Nelsoni Ranch. De esta manera nuestro seguimiento de la materia prima se realiza desde el nacimiento en el campo para poder asegurar un alto estándar de calidad en el producto terminado. \nDurante el año 2016, teniendo ya desarrollada una línea de Heno y Pasturas en diferentes presentaciones, consideramos que era momento de asegurar la mejor calidad comenzando a producir las pasturas en nuestras praderas de Alfalfa, Lotus, Trébol y Cebadilla."),_c('br'),_c('br'),_vm._v("\nAsí comenzó la historia de la empresa dedicada a pequeñas mascotas más importante de la Argentina. \nSu excelente calidad, su atención personalizada y la correcta selección de componentes en sus presentaciones hicieron a Nelsoni Ranch la empresa líder en productos para pequeñas mascotas.\n\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])]),_vm._v(" "),_c('div',{staticClass:"float-png"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section bg-green"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-5"},[_c('h1',{staticClass:"title white"},[_vm._v("\n              BIO ORGANIC\n            ")]),_vm._v(" "),_c('p',{staticClass:"description white"},[_vm._v("\n            Nuestro sello representa el origen de nuestras materias primas, respetando el medio ambiente, la naturaleza y el bienestar animal."),_c('br'),_c('br'),_vm._v("\nNuestros productos son naturales, sus componentes mantienen un alto estándar de calidad."),_c('br'),_c('br'),_vm._v("\nDurante el proceso de fabricación no utilizamos productos químicos, eliminando los riesgos que tienen dichos productos en la salud de las mascotas."),_c('br'),_c('br'),_vm._v("\nPensamos en un mundo más verde, siguiendo políticas sustentables desarrollando productos orgánicos y biodegradables.\n\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column is-3 img-center"},[_c('img',{attrs:{"src":__webpack_require__("C0jm"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section bg-bird"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns "},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-8 img-center has-text-centered"},[_c('img',{attrs:{"src":__webpack_require__("0p7L"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"description white"},[_vm._v("\n              ANIMALES, SANOS FUERTES Y FELICES.\n              "),_c('br'),_vm._v(" NUESTRO OBJETIVO ES LOGRAR ALIMENTOS Y PRODUCTOS "),_c('br'),_vm._v(" CADA VEZ MEJORES PARA TUS MASCOTAS.\n            ")]),_vm._v(" "),_c('div',{staticClass:"green-box-button "},[_vm._v("\n\n              UNA MASCOTA SANA "),_c('br'),_vm._v(" ES UNA MASCOTA FELIZ.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RirS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('section',{staticClass:"section main-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-3"}),_vm._v(" "),_c('div',{staticClass:"column is-6 "},[_vm._m(0),_vm._v(" "),_c('form',{attrs:{"method":"POST"},on:{"submit":function($event){_vm.submit($event)}}},[(_vm.submitting)?_c('div',{staticClass:"loading"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.firstName),expression:"formData.firstName"}],staticClass:"input",attrs:{"required":"","type":"text","placeholder":"Nombre*"},domProps:{"value":(_vm.formData.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "firstName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"input",attrs:{"type":"text","placeholder":"Teléfono"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.lastName),expression:"formData.lastName"}],staticClass:"input",attrs:{"type":"text","required":"","placeholder":"Apellido*"},domProps:{"value":(_vm.formData.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"input",attrs:{"type":"email","required":"","placeholder":"E-mail*"},domProps:{"value":(_vm.formData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.message),expression:"formData.message"}],staticClass:"textarea",attrs:{"required":"","placeholder":"Escriba aquí sus comentarios*"},domProps:{"value":(_vm.formData.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "message", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('p',[_vm._v("\n                    Por favor antes de enviar haga click en el siguiente casillero para comprobar que usted no es un sistema automático (Spammer)\n                  ")]),_vm._v(" "),_c('div',{staticClass:"recaptcha"},[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"recaptcha"}}),_vm._v(" "),(_vm.submitted && !_vm.formData.reCaptcha)?_c('p',{staticClass:"help is-danger"},[_vm._v("Por favor valide que no es un robot!")]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v("\n                    (*) campos marcados con * son obligatorios\n                  ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),(_vm.notification.show)?_c('div',{staticClass:"notification",class:_vm.notification.type},[(_vm.notification.type === 'is-success')?_c('h2',[_vm._v("Su mensaje ha sido enviado correctamente!")]):_vm._e(),_vm._v(" "),(_vm.notification.type === 'is-danger')?_c('h2',[_vm._v("Ups.. ha surgido un error, intente nuevamente más tarde")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column is-3"})])]),_vm._v(" "),_c('div',{staticClass:"float-png"})]),_vm._v(" "),_c('web-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info"},[_c('p',[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n              15-5149-6996\n            ")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v("\n              CONTACTO@NELSONIRANCH.COM.AR\n            ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.facebook.com/NelsoniRanch/?ref=br_rs","target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook-official",attrs:{"aria-hidden":"true"}}),_vm._v("\n              NELSONIRANCH\n              ")])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.instagram.com/nelsoniranch/","target":"_blank"}},[_c('i',{staticClass:"fa fa-instagram",attrs:{"aria-hidden":"true"}}),_vm._v("\n              NELSONIRANCH \n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_vm._v(" "),_c('div',{staticClass:"bounce2"}),_vm._v(" "),_c('div',{staticClass:"bounce3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('p',[_c('button',{staticClass:"button is-info"},[_vm._v("Enviar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S4JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("bBBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af05ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("RirS");
function injectStyle (ssrContext) {
  __webpack_require__("u+W5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1af05ab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af05ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SFjt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pasturas_alfalfaencubos.6c79dea.jpg";

/***/ }),

/***/ "Shio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-content'),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TDqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__ = __webpack_require__("AzBG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d06e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__ = __webpack_require__("wLMi");
function injectStyle (ssrContext) {
  __webpack_require__("HwwY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15d06e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d06e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TMRu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.d9e4c15.jpg";

/***/ }),

/***/ "Toxu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_periquitos.17db61e.jpg";

/***/ }),

/***/ "U70l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "data-table",
  data: function data() {
    return {
      chinchillas: "chinchillas",
      conejos: "conejos"
    };
  },

  props: {
    type: String
  }
});

/***/ }),

/***/ "Up9V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VQz7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_completefood.12d2741.jpg";

/***/ }),

/***/ "VqlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_bedding_jpg__ = __webpack_require__("jN9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_bedding_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_bedding_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_bedding_mobile_jpg__ = __webpack_require__("qp/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_bedding_mobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_bedding_mobile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_bedding_virutademarlo_jpg__ = __webpack_require__("pZ5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_bedding_virutademarlo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_bedding_virutademarlo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_bedding_marloparagatos_jpg__ = __webpack_require__("WuW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_bedding_marloparagatos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_bedding_marloparagatos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_bedding_marlopararoedores_jpg__ = __webpack_require__("E8nv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_bedding_marlopararoedores_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_products_bedding_marlopararoedores_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BeddingAndLibtterCamas",
  data: function data() {
    return {
      data: [{
        html: " <h1>BEDDING &amp; LITTER <br> CAMAS</h1><p>Elaborado en su totalidad por marlo de maíz molido el cuál brinda un ALTO PODER DE ABSORCIÓN RETIENE los OLORES y resulta muy RENDIDOR economizando su compra. </p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_products_bedding_marlopararoedores_jpg___default.a,
        title: "MARLO PARA ROEDORES Y AVES / CORN COB BED / ABSORBENTE SANITARIO ",
        description: "Se recomienda el uso en camas de pequeñas mascotas como  hámster, cobayo, conejos, ferrets (hurones) y erizos. Otra excelente aplicación se encuentra en jaulas de aves usando el marlo como base en la bandeja de la jaula favoreciendo el control de olores y absorbiendo excesos de humedad. No se recomienda el uso en iguanas.",
        extraData: "Presentación 1,2 Kg. /4 Kg./14 Kg."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_bedding_virutademarlo_jpg___default.a,
        title: "VIRUTA DE MARLO",
        description: "Excelente cama para mascotas tales conejos, cobayos, hamsters, chinchillas, erizos y otros animales que requieran de un entorno saludable. SUPER ABSORBENTE y libre de polvo. Facilita el armado de nidos. La Viruta de Marlo es 100% biodegradable, producto apto para compostar.",
        extraData: "Presentación: 500 gr. / 2,5 kg. / 10 kg."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_bedding_marloparagatos_jpg___default.a,
        title: "MARLO PARA GATOS / CORN COB BED / ABSORBENTE SANITARIO",
        description: "Se recomienda el uso en las literas de los gatos, favoreciendo el control de olores y                   absorbiendo excesos de humedad.\n                    <p>\n                    -\tNo t\xF3xico </br>\n                    -\tExcelente control de olores </br>\n                    -\tF\xE1cil de limpiar: no se pega en la litera y el producto es muy liviano </br>\n                    -\tAbsorbe 4 veces m\xE1s que las camas convencionales\n                    </p>\n                    <p>\n                    El marlo es un absorbente sanitario de origen natural, vegetal, constituido \xFAnicamente con mazorcas de ma\xEDz.\n                    </p>\n                    <p>\n                    Nuestro producto se tamiza para asegurar una superficie confortable para su mascota. No contiene arcilla, ni colorantes, ni perfume. Libre de polvo para brindarle un entorno m\xE1s saludable para \n                    su gato.\n                    </p>\n                    <p>\n                    El marlo funciona mediante la absorci\xF3n de la orina del gato y se caracteriza por su alto nivel de evaporaci\xF3n reteniendo en este proceso los intensos olores.\n                    Tambi\xE9n puede utilizarse en otros animales peque\xF1os como aves, hurones, conejos y otros roedores.\n                    </p>\n                    <p>\n                    Instrucciones de Uso:\n                    </p>\n                    <p>\n                    Debe llenar la litera con 2 \xF3 3 cm de producto, cantidad que le permite a usted una f\xE1cil limpieza y a su gato le brinda el suficiente material para enterrar sus residuos.\n                    Es recomendable quitar los residuos s\xF3lidos diariamente y cuando el producto pierda su capacidad de absorci\xF3n debe vaciar la litera, lavarla y reemplazar por material fresco.\n                    Nota: mientras que algunos gatos pueden cambiar de un tipo de absorbente a otro con facilidad, su gato puede requerir una transici\xF3n.  Si es as\xED, usted debe seguir estos simples pasos:\n                    </p>\n                    <p>\n                    Semana  1: mezcle 1/3 de marlo con su absorbente actual</br>\n                    Semana 2: mezcle \xBD de marlo y \xBD de su absorbente actual</br>\n                    Semana 3: utilice 100% la cama de marlo.\n                    </p>",
        extraData: "Presentación 1,2 Kg. /4 Kg. /14 Kg."
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_bedding_mobile_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_bedding_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "WKFJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/completefood_chinchillas.f1a8961.jpg";

/***/ }),

/***/ "WuW0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bedding_marloparagatos.27de425.jpg";

/***/ }),

/***/ "X8G4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/suplementos_eggbiscuits.003abcf.jpg";

/***/ }),

/***/ "Y9K9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_products__ = __webpack_require__("nKQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_aboutUs__ = __webpack_require__("ztxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact__ = __webpack_require__("S4JM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_categories_beddingAndLitterCamas__ = __webpack_require__("8nYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_categories_naturalHayPasturas__ = __webpack_require__("ltbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_categories_naturalMixAves__ = __webpack_require__("Za7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_categories_naturalMixRoedores__ = __webpack_require__("By9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_categories_completeFood__ = __webpack_require__("GaaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_categories_suplementos__ = __webpack_require__("CLTj");













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }, {
    path: '/productos',
    name: 'products',
    component: __WEBPACK_IMPORTED_MODULE_3__components_products__["a" /* default */]
  }, {
    path: '/nosotros',
    name: 'aboutUs',
    component: __WEBPACK_IMPORTED_MODULE_4__components_aboutUs__["a" /* default */]
  }, {
    path: '/contacto',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_5__components_contact__["a" /* default */]
  }, {
    path: '/bedding-and-litter-camas',
    name: 'beddingAndLitterCamas',
    component: __WEBPACK_IMPORTED_MODULE_6__components_categories_beddingAndLitterCamas__["a" /* default */]
  }, {
    path: '/natural-hay-pasturas',
    name: 'naturalHayPasturas',
    component: __WEBPACK_IMPORTED_MODULE_7__components_categories_naturalHayPasturas__["a" /* default */]
  }, {
    path: '/natural-mix-aves',
    name: 'naturalMixAves',
    component: __WEBPACK_IMPORTED_MODULE_8__components_categories_naturalMixAves__["a" /* default */]
  }, {
    path: '/natural-mix-roedores',
    name: 'naturalMixRoedores',
    component: __WEBPACK_IMPORTED_MODULE_9__components_categories_naturalMixRoedores__["a" /* default */]
  }, {
    path: '/complete-food',
    name: 'completeFood',
    component: __WEBPACK_IMPORTED_MODULE_10__components_categories_completeFood__["a" /* default */]
  }, {
    path: '/suplementos',
    name: 'suplementos',
    component: __WEBPACK_IMPORTED_MODULE_11__components_categories_suplementos__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZPdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__ = __webpack_require__("OLGF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1065e220_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_vue__ = __webpack_require__("e0Xg");
function injectStyle (ssrContext) {
  __webpack_require__("4YMM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1065e220"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1065e220_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Za7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalMixAves_vue__ = __webpack_require__("w44L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2be97d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalMixAves_vue__ = __webpack_require__("3CwX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalMixAves_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2be97d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalMixAves_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zz+1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pasturas_henoenrama.11f5ed5.jpg";

/***/ }),

/***/ "bBBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_contact_contacto_titulo_jpg__ = __webpack_require__("jWDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_contact_contacto_titulo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_contact_contacto_titulo_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        message: '',
        reCaptcha: ''
      },
      submitting: false,
      widgetId1: null,
      submitted: false,
      notification: {
        show: false,
        type: ''
      },
      data: [{
        html: ' <h1>CONTACTO</h1>',
        style: "background:url(" + __WEBPACK_IMPORTED_MODULE_3__assets_images_contact_contacto_titulo_jpg___default.a + ") no-repeat; background-size:cover; background-position: center; height:300px;"
      }]
    };
  },

  methods: {
    resetForm: function resetForm() {
      this.initReCaptcha();
      this.formData.firstName = null;
      this.formData.lastName = null;
      this.formData.email = null;
      this.formData.message = null;
      this.formData.phone = null;
      this.formData.reCaptcha = null;
      this.submitted = false;
    },
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      this.submitted = true;
      if (this.formData.reCaptcha && this.formData.firstName && this.formData.lastName && this.formData.email && this.formData.message) {
        this.submitting = true;
        $.ajax({
          method: "POST",
          url: "http://nelsoniranch.com.ar/send.php",
          data: this.formData
        }).done(function (res) {
          _this.submitting = false;
          var resVal = JSON.parse(res);
          _this.resetForm();
          _this.notificationHandler(resVal);
        });
      }
    },
    notificationHandler: function notificationHandler(resVal) {
      var _this2 = this;

      if (!resVal.error) {
        this.notification.type = 'is-success';
      } else {
        this.notification.type = 'is-danger';
      }

      this.notification.show = true;
      setTimeout(function () {
        _this2.notification.show = false;
      }, 15000);
    },

    setToken: function setToken(token) {
      this.formData.reCaptcha = token;
    },
    initReCaptcha: function initReCaptcha() {
      var _this3 = this;

      setTimeout(function () {
        if (typeof grecaptcha === 'undefined') {
          _this3.initReCaptcha();
        } else {
          _this3.widgetId1 = grecaptcha.render('recaptcha', {
            sitekey: '6LfK_TMUAAAAAKJQzCFfN7YhA2SuPchxuCWuto_G',
            badge: 'inline',
            callback: _this3.setToken
          });
        }
      }, 100);
    }
  },
  components: {
    'webHeader': __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    'webSlide': __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    'webFooter': __WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */]
  },
  mounted: function mounted() {
    this.initReCaptcha();
  }
});

/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),

/***/ "e0Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},_vm._l((_vm.categories),function(cols){return _c('div',{staticClass:"columns "},_vm._l((cols),function(product){return _c('div',{staticClass:"column has-text-centered wow fadeIn",attrs:{"data-wow-delay":product.delay}},[_c('div',{staticClass:"box-products has-text-centered"},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_c('router-link',{attrs:{"to":product.link}},[_vm._v("Ver productos!")])],1)]),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(product.title)}}),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n              "+_vm._s(product.description)+"\n            ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":product.image,"alt":product.description}})])])])}))}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner has-text-centered"},[_c('h3',[_vm._v("NUESTROS PRODUCTOS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f0Vq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixroedores_hamsters.db59dea.jpg";

/***/ }),

/***/ "flZL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_suplementos.b73f399.jpg";

/***/ }),

/***/ "gfTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i9fM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('ul',[_c('li',[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n            (+54 - 11) 15-5149-6996\n          ")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v("\n            contacto@nelsoniranch.com.ar\n          ")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/NelsoniRanch","target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook-official",attrs:{"aria-hidden":"true"}}),_vm._v("\n              NelsoniRanch\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('span',{staticClass:"icon-logoNelsoniRanch_blanco"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ie3P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_alpiste.5664dcb.jpg";

/***/ }),

/***/ "jE5B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.72d1c92.jpg";

/***/ }),

/***/ "jN9t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_bedding.9656bf9.jpg";

/***/ }),

/***/ "jSzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"carousel",attrs:{"data-flickity":""}},_vm._l((_vm.data),function(item){return _c('div',{staticClass:"carousel-cell container-fluid has-text-centered",class:item.className,style:(item.style)},[_c('div',{staticClass:"text-box"},[_c('div',{staticClass:"text-center wow bounceInDown"},[_c('div',{domProps:{"innerHTML":_vm._s(item.html)}}),_vm._v(" "),(item.link)?_c('p',[_c('router-link',{attrs:{"to":item.link.href}},[_vm._v(_vm._s(item.link.text))])],1):_vm._e()])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jWDT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contacto_titulo.110a8dd.jpg";

/***/ }),

/***/ "kfbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrowUp',
  data: function data() {
    return {
      scrolled: false
    };
  },

  methods: {
    scrollTop: function scrollTop() {
      var body = $("html, body");
      body.stop().animate({ scrollTop: 0 }, 500, 'swing');
    },
    handleScroll: function handleScroll() {
      this.scrolled = window.scrollY > 200;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "lDr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("EZOG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c62bfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("jSzX");
function injectStyle (ssrContext) {
  __webpack_require__("Mccf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c62bfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ltbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalHayPasturas_vue__ = __webpack_require__("1c46");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8547ea24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalHayPasturas_vue__ = __webpack_require__("tSvn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_naturalHayPasturas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8547ea24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_naturalHayPasturas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mdd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arrowUp_vue__ = __webpack_require__("kfbB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42525b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrowUp_vue__ = __webpack_require__("uuZx");
function injectStyle (ssrContext) {
  __webpack_require__("P1EU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arrowUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42525b22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrowUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0444acc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("i9fM");
function injectStyle (ssrContext) {
  __webpack_require__("EQB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0444acc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0444acc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__ = __webpack_require__("MOSm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4ac869a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__ = __webpack_require__("5dYx");
function injectStyle (ssrContext) {
  __webpack_require__("OZUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4ac869a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oYez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pZ5q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bedding_virutademarlo.aca8189.jpg";

/***/ }),

/***/ "qp/Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_bedding_mobile.9ee605e.jpg";

/***/ }),

/***/ "t4Qx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titulo_mixaves.5f14311.jpg";

/***/ }),

/***/ "tPY+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.b1a6df6.jpg";

/***/ }),

/***/ "tSvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section wow fadeIn"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"}),_vm._v(" "),_c('div',{staticClass:"column is-9 has-text-centered"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__("HXVv"),"alt":"piramide_pasturas"}})])]),_vm._v(" "),_c('div',{staticClass:"column is-2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u+W5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uh6F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_loros.cd72a6d.jpg";

/***/ }),

/***/ "uuZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scrolled)?_c('div',{staticClass:"arrow-box"},[_c('a',{staticClass:"button",on:{"click":_vm.scrollTop}},[_c('i',{staticClass:"fa fa-arrow-up",attrs:{"aria-hidden":"true"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vgE3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/suplementos_hical.006c3ea.jpg";

/***/ }),

/***/ "w44L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_slide__ = __webpack_require__("lDr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_categories_products__ = __webpack_require__("I9g3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__ = __webpack_require__("mdd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixaves_jpg__ = __webpack_require__("t4Qx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixaves_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixaves_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixaves_mobile_jpg__ = __webpack_require__("5w5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixaves_mobile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixaves_mobile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixaves_periquitos_jpg__ = __webpack_require__("Toxu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixaves_periquitos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixaves_periquitos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixaves_silvestres_jpg__ = __webpack_require__("2qj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixaves_silvestres_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixaves_silvestres_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_mixaves_canarios_jpg__ = __webpack_require__("xvAg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_products_mixaves_canarios_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_products_mixaves_canarios_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_products_mixaves_loros_jpg__ = __webpack_require__("uh6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_products_mixaves_loros_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_products_mixaves_loros_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_products_mixaves_alpiste_jpg__ = __webpack_require__("ie3P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_products_mixaves_alpiste_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_products_mixaves_alpiste_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_products_mixaves_girasol_jpg__ = __webpack_require__("Hkbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_products_mixaves_girasol_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_products_mixaves_girasol_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_products_mixaves_mijo_jpg__ = __webpack_require__("4puZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_products_mixaves_mijo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_products_mixaves_mijo_jpg__);
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "naturalMixAves",
  data: function data() {
    return {
      data: [{
        html: " <h1>NATURAL MIX - AVES</h1><p>Alimento a base de materias primas de primera calidad que constituye una dieta balanceada a la medida de sus aves</p>",
        style: "background:url(" + this.getBg() + ") no-repeat; background-size:cover;    background-position: center; height:300px; "
      }],
      products: [{
        image: __WEBPACK_IMPORTED_MODULE_9__assets_images_products_mixaves_periquitos_jpg___default.a,
        title: "MIX PERIQUITOS",
        description: "El Mix para Periquitos de Nelsoni Ranch Especialmente formulado para peque\xF1os psit\xE1cidos como periquitos australianos, variedades de agapornis, entre otros.<br>\nIngredientes: mijo rojo, mijo verde, mijo amarillo, alpiste, girasol rayado chico, avena pelada, c\xE1rtamo, con vitaminas.",
        extraData: "Presentación 750 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_10__assets_images_products_mixaves_silvestres_jpg___default.a,
        title: "MIX SILVESTRES",
        description: "El Mix para p\xE1jaros Silvestres de Nelsoni Ranch Especialmente formulado para p\xE1jaros silvestres como diamantes de Gould, Mandarin, jilgueros entre otros.<br>\nIngredientes: mijo rojo, mijo verde, mijo amarillo, colza (canola), alpiste, con vitaminas.\n",
        extraData: "Presentación 750 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_11__assets_images_products_mixaves_canarios_jpg___default.a,
        title: "MIX CANARIOS",
        description: "El Mix para Canarios de Nelsoni Ranch provee una optima nutrici\xF3n con todas las vitaminas y nutrientes que las mejores semillas pueden dar, manteniendo a su canario vital y feliz. <br>\nIngredientes: alpiste, colza (canola), avena pelada, lino, con vitaminas.\n",
        extraData: "Presentación 750 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_12__assets_images_products_mixaves_loros_jpg___default.a,
        title: "MIX LOROS",
        description: "\nEl Mix para loros de Nelsoni Ranch Especialmente formulado para psit\xE1cidos de porte mediano a grande como guacamayos, loros amaz\xF3nicos,  entre otros.<br>\nSe recomienda suplementar su alimentaci\xF3n con frutas de estaci\xF3n.<br>\nIngredientes: girasol confitero grande, semillas de zapallo, man\xED con c\xE1scara, c\xE1rtamo, trigo sarraceno, trigo candeal, ma\xEDz, avena, cebada.\n",
        extraData: "Presentación 600 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_13__assets_images_products_mixaves_alpiste_jpg___default.a,
        title: "ALPISTE CON VITAMINAS",
        description: "Seleccionamos  las semillas de la mejor calidad, libres de polvo y cascarillas. Nuestro Alpiste viene con vitaminas",
        extraData: "Presentación 750 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_14__assets_images_products_mixaves_girasol_jpg___default.a,
        title: "GIRASOL CONFITERO",
        description: "Semillas de girasol confitero de la mejor calidad seleccionadas para una excelente nutrici\xF3n. <br>Libres de polvo y cascarillas con el m\xE1s grande y mejor tama\xF1o que su mascota prefiere.",
        extraData: "Presentación 400 gr. y 10 kilos."
      }, {
        image: __WEBPACK_IMPORTED_MODULE_15__assets_images_products_mixaves_mijo_jpg___default.a,
        title: "MIJO CON VITAMINAS",
        description: "Semillas de la mejor calidad seleccionadas para una excelente nutrici\xF3n.<br>\nLibres de polvo y cascarillas. con vitaminas",
        extraData: "Presentación 750 gr. y 10 kilos"
      }]
    };
  },

  components: {
    webHeader: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    webSlide: __WEBPACK_IMPORTED_MODULE_1__components_slide__["a" /* default */],
    webContent: __WEBPACK_IMPORTED_MODULE_2__components_content__["a" /* default */],
    webParallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */],
    webFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer__["a" /* default */],
    webProducts: __WEBPACK_IMPORTED_MODULE_5__components_categories_products__["a" /* default */],
    webArrowUp: __WEBPACK_IMPORTED_MODULE_6__components_arrowUp_vue__["a" /* default */]
  },
  methods: {
    detectmob: function detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg: function getBg() {
      if (this.detectmob()) {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_categories_banners_titulo_mixaves_mobile_jpg___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_7__assets_images_categories_banners_titulo_mixaves_jpg___default.a;
    }
  }
});

/***/ }),

/***/ "wLMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapper-parallax"},[_c('div',{staticClass:"parallax"}),_vm._v(" "),_c('h2',[_vm._v("\n        DESDE NUESTRA PLANTA ELABORADORA EN SAN PEDRO, BUENOS AIRES (ARGENTINA) OFRECEMOS LA MEJOR CALIDAD EN PRODUCTOS PARA MASCOTAS.\n      ")]),_vm._v(" "),_c('div',{staticClass:"bg-bird"}),_vm._v(" "),_c('div',{staticClass:"content-bg-green"},[_c('div',{staticClass:"content-text"},[_c('div',[_vm._v("\n           Nuestros productos son naturales, sus componentes mantienen un alto estándar de calidad.\nDurante el proceso de fabricación no utilizamos productos químicos, eliminando los riesgos que tienen dichos productos en la salud de las mascotas.\nPensamos en un mundo más verde, siguiendo políticas sustentables desarrollando productos orgánicos y biodegradables.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"bio"})]),_vm._v(" "),_c('div',{staticClass:"second-banner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffc8c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("Shio");
function injectStyle (ssrContext) {
  __webpack_require__("Y9K9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffc8c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wgpE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/suplementos_calcioreptiles.c203153.jpg";

/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  methods: {
    path: function path(pathName) {
      if (typeof pathName != "string") {
        var className = null;
        pathName.forEach(function (item, i) {
          if (window.location.pathname === item) {
            className = 'active';
          }
        });
        return className;
      }
      return window.location.pathname === pathName ? 'active' : null;
    }
  },
  mounted: function mounted() {
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
    if ($navbarBurgers.length > 0) {
      $navbarBurgers.forEach(function ($el) {
        $el.addEventListener('click', function () {
          var target = $el.dataset.target;
          var $target = document.getElementById(target);
          $el.classList.toggle('is-active');
          $target.classList.toggle('is-active');
        });
      });
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xvAg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mixaves_canarios.97d98e3.jpg";

/***/ }),

/***/ "y/vF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ztxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__ = __webpack_require__("A1ge");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513b7074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__ = __webpack_require__("R0Ni");
function injectStyle (ssrContext) {
  __webpack_require__("CMs/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-513b7074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513b7074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ac2d5ea494ff1e6dfa91.js